import ResendAccessButton from './ResendAccessButton';

export default ResendAccessButton;
